import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import React, { useEffect, useRef, useState } from "react";
import Navbar from "../Components/Navbar/navbar";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { useHistory } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import DescriptionIcon from "@mui/icons-material/Description";
import LinkIcon from "@mui/icons-material/Link";
import Tooltip from "@mui/material/Tooltip";



import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  CircularProgress,
  TextField,
  Button,
  Stack,
} from "@mui/material";

import { collection, getDocs } from "firebase/firestore";
import { db } from "../Config/firebase";
import * as XLSX from "xlsx";
import { consultaTenantAtual } from "../Utils/tenant";
import { BotaoExportarLista } from "../Components/ExportarLista/ExportarLista";

/* =========================
   CABEÇALHO SGQ
========================= */
const CABECALHO_SGQ = {
  titulo: "LISTA MESTRA – CONTROLE DE INFORMAÇÃO DOCUMENTADA",
  subtitulo: "Sistema de Gestão da Qualidade",
  codigo: "RQ 1.1",
  versao: "Versão 01",
  aprovacao: "Aprov. em 18/06/2025",
};

function ordenarPorCodigoDocumento(a, b) {
  const codigoA = String(a.codigoISO || "").trim().toUpperCase();
  const codigoB = String(b.codigoISO || "").trim().toUpperCase();

  function obterOrdem(codigo) {
    const correspondencia = codigo.match(/^(MQ|POP|RQ)\s*-?\s*(\d+(?:\.\d+)*)?/);

    if (!correspondencia) {
      return {
        grupoPrincipal: 9999,
        tipo: 9999,
        partes: [],
        codigo,
      };
    }

    const tipoDocumento = correspondencia[1];
    const partes = (correspondencia[2] || "0")
      .split(".")
      .map((numero) => Number(numero));

    if (tipoDocumento === "MQ") {
      return {
        grupoPrincipal: -1,
        tipo: 0,
        partes,
        codigo,
      };
    }

    return {
      grupoPrincipal: partes[0] || 0,
      tipo: tipoDocumento === "POP" ? 0 : 1,
      partes,
      codigo,
    };
  }

  const ordemA = obterOrdem(codigoA);
  const ordemB = obterOrdem(codigoB);

  if (ordemA.grupoPrincipal !== ordemB.grupoPrincipal) {
    return ordemA.grupoPrincipal - ordemB.grupoPrincipal;
  }

  if (ordemA.tipo !== ordemB.tipo) {
    return ordemA.tipo - ordemB.tipo;
  }

  const maiorQuantidadePartes = Math.max(
    ordemA.partes.length,
    ordemB.partes.length
  );

  for (let i = 0; i < maiorQuantidadePartes; i += 1) {
    const numeroA = ordemA.partes[i] || 0;
    const numeroB = ordemB.partes[i] || 0;

    if (numeroA !== numeroB) {
      return numeroA - numeroB;
    }
  }

  return ordemA.codigo.localeCompare(ordemB.codigo, "pt-BR", {
    numeric: true,
  });
}

export default function ListaMestra() {
  const [documentos, setDocumentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busca, setBusca] = useState("");
  const [larguraRolagem, setLarguraRolagem] = useState(1800);
  const tabelaRef = useRef(null);
  const barraInferiorRef = useRef(null);
  const storage = getStorage();
  const history = useHistory();

  useEffect(() => {
    carregarLista();
  }, []);

  useEffect(() => {
    if (loading) return undefined;

    function atualizarLarguraRolagem() {
      const tabela = tabelaRef.current;
      const barra = barraInferiorRef.current;
      if (!tabela || !barra) return;

      const diferencaLargura = Math.max(0, barra.clientWidth - tabela.clientWidth);
      setLarguraRolagem(tabela.scrollWidth + diferencaLargura);
    }

    const quadro = window.requestAnimationFrame(atualizarLarguraRolagem);
    window.addEventListener("resize", atualizarLarguraRolagem);
    return () => {
      window.cancelAnimationFrame(quadro);
      window.removeEventListener("resize", atualizarLarguraRolagem);
    };
  }, [loading, documentos.length]);

  /* =========================
     FIRESTORE
  ========================= */
  async function carregarLista() {
    try {
      const snap = await getDocs(consultaTenantAtual(collection(db, "sgq_documentos")));
      const lista = snap.docs
      .map((d) => ({ id: d.id, ...d.data() }))
      .sort(ordenarPorCodigoDocumento);
      setDocumentos(lista);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  /* =========================
     UTIL
  ========================= */
  function formatarDataBR(data) {
    if (!data) return "";
    const [ano, mes, dia] = data.split("-");
    return `${dia}/${mes}/${ano}`;
  }

  function filtrarDocumentos(doc) {
    if (!busca) return true;
    return contemTextoPesquisa(Object.values(doc)
      .join(" ")
      .toLowerCase(), busca.toLowerCase());
  }

  async function abrirDocumento(doc) {
    if (!doc.storagePath) return;
    try {
      const url = await getDownloadURL(ref(storage, doc.storagePath));
      window.open(url, "_blank");
    } catch (e) {
      console.error("Erro ao abrir documento:", e);
    }
  }

                      async function abrirItem(doc) {
              // 🔗 MESMA LÓGICA DO ADMIN SGQ
              if (doc.origemDocumento === "rota" && doc.rotaInterna) {
                history.push(doc.rotaInterna);
                return;
              }

              // 📄 PDF
              abrirDocumento(doc);
            }



  /* =========================
     EXPORTAR EXCEL
  ========================= */
  function exportarExcel() {
    const dados = documentos.map((doc) => ({
        Código: doc.codigoISO,
        Título: doc.titulo,
        Tipo: doc.tipo,
        Versão: `REV.${doc.revisaoAtual}`,
        "Data de Emissão": formatarDataBR(doc.dataEmissao),
        Responsável: doc.responsavel,
        Status: doc.status,
        "Local de Armazenamento": doc.localArmazenamento,
        Observações: doc.observacoes,
        "Dados Pessoais Sensíveis?": doc.dadosSensiveis,
        "Tipo de Dado": doc.tipoDado,
        "Justificativa do Tratamento": doc.justificativaTratamento,
        "Acesso Restrito?": doc.acessoRestrito,
        "Medida de Proteção": doc.medidaProtecao,
      }));


    const ws = XLSX.utils.json_to_sheet(dados, { origin: "A6" });

    XLSX.utils.sheet_add_aoa(
      ws,
      [
        [CABECALHO_SGQ.titulo],
        [CABECALHO_SGQ.subtitulo],
        [],
        ["Código:", CABECALHO_SGQ.codigo, "", "Versão:", CABECALHO_SGQ.versao],
        ["Aprovação:", CABECALHO_SGQ.aprovacao],
      ],
      { origin: "A1" }
    );

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Lista Mestra");
    XLSX.writeFile(wb, "lista-mestra-sgq.xlsx");
  }

  /* =========================
     EXPORTAR PDF (CORRIGIDO)
  ========================= */
  function exportarPDF() {
    const pdf = new jsPDF("l", "mm", "a4");

    pdf.setFontSize(14);
    pdf.text(CABECALHO_SGQ.titulo, 14, 15);

    pdf.setFontSize(10);
    pdf.text(CABECALHO_SGQ.subtitulo, 14, 22);

    pdf.setFontSize(9);
    pdf.text(`Código: ${CABECALHO_SGQ.codigo}`, 14, 30);
    pdf.text(`Versão: ${CABECALHO_SGQ.versao}`, 120, 30);
    pdf.text(`Aprovação: ${CABECALHO_SGQ.aprovacao}`, 200, 30);

    autoTable(pdf, {
  head: [[
    "Código",
    "Título",
    "Tipo",
    "Versão",
    "Data de Emissão",
    "Responsável",
    "Status",
    "Local de Armazenamento",
    "Observações",
    "Dados Pessoais Sensíveis?",
    "Tipo de Dado",
    "Justificativa do Tratamento",
    "Acesso Restrito?",
    "Medida de Proteção",
  ]],

  body: documentos.map((doc) => [
    doc.codigoISO,
    doc.titulo,
    doc.tipo,
    `REV.${doc.revisaoAtual}`,
    formatarDataBR(doc.dataEmissao),
    doc.responsavel,
    doc.status,
    doc.localArmazenamento,
    doc.observacoes,
    doc.dadosSensiveis,
    doc.tipoDado,
    doc.justificativaTratamento,
    doc.acessoRestrito,
    doc.medidaProtecao,
  ]),

  startY: 38,

  styles: {
    fontSize: 7,
    cellPadding: 1.5,
    overflow: "linebreak",
  },

  headStyles: {
    fillColor: [230, 230, 230],
    textColor: [0, 32, 96],
  },

  columnStyles: {
    0: { cellWidth: 16 },
    1: { cellWidth: 36 },
    2: { cellWidth: 12 },
    3: { cellWidth: 14 },
    4: { cellWidth: 18 },
    5: { cellWidth: 23 },
    6: { cellWidth: 14 },
    7: { cellWidth: 28 },
    8: { cellWidth: 26 },
    9: { cellWidth: 17 },
    10: { cellWidth: 18 },
    11: { cellWidth: 28 },
    12: { cellWidth: 14 },
    13: { cellWidth: 26 },
  },

  margin: { left: 2.5, right: 2.5 },
});


    pdf.save("lista-mestra-sgq.pdf");
  }

  /* =========================
     UI
  ========================= */
  if (loading) {
    return (
      <Box sx={{ p: 4, textAlign: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Navbar />

      <Box sx={{ p: 3, pb: 5, backgroundColor: "#f5f6f8", minHeight: "100vh" }}>
        <Paper sx={{ p: 3, borderRadius: 2, border: "1px solid", borderColor: "divider" }}>
          <Box mb={3}>
  <Typography
    variant="h6"
    fontWeight={700}
    textTransform="uppercase"
  >
    {CABECALHO_SGQ.titulo}
  </Typography>

  <Typography variant="body2" color="text.secondary" mb={1}>
    {CABECALHO_SGQ.subtitulo}
  </Typography>

  <Stack
    direction="row"
    justifyContent="space-between"
    sx={{ maxWidth: 700 }}
              >
                <Typography variant="caption">
                  <strong>Código:</strong> {CABECALHO_SGQ.codigo}
                </Typography>

                <Typography variant="caption">
                  <strong>Versão:</strong> {CABECALHO_SGQ.versao}
                </Typography>

                <Typography variant="caption">
                  <strong>Aprovação:</strong> {CABECALHO_SGQ.aprovacao}
                </Typography>
              </Stack>
            </Box>


          <Stack direction="row" spacing={2} mb={2}>
            <TextField
              placeholder="Pesquisar documentos"
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
              size="small"
              fullWidth
            />

            <BotaoExportarLista onExcel={exportarExcel} onPdf={exportarPDF} />

          </Stack>

          <TableContainer
            ref={tabelaRef}
            onScroll={(event) => {
              if (barraInferiorRef.current) {
                barraInferiorRef.current.scrollLeft = event.currentTarget.scrollLeft;
              }
            }}
            sx={{ overflowX: "auto", scrollbarWidth: "none", "&::-webkit-scrollbar": { display: "none" } }}
          >
            <Table stickyHeader size="small" sx={{ minWidth: 1800 }}>
              <TableHead>
                <TableRow>
                  {[
                        "Código","Título","Tipo","Versão","Data de Emissão","Responsável",
                        "Status","Local de Armazenamento","Observações",
                        "Dados Pessoais Sensíveis?","Tipo de Dado",
                        "Justificativa do Tratamento","Acesso Restrito?","Medida de Proteção"
                      ]
                     .map((h, index) => (
                        <TableCell
                          key={h}
                          sx={
                            index === 0
                              ? {
                                  whiteSpace: "nowrap",
                                  minWidth: 90,
                                  width: 90,
                                }
                              : undefined
                          }
                        >
                          {h}
                        </TableCell>
                      ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {documentos.filter(filtrarDocumentos).map((doc) => (
                  <TableRow key={doc.id} hover>
                    <TableCell
                    sx={{
                      whiteSpace: "nowrap",
                      minWidth: 90,
                      width: 90,
                    }}
                  >
                    {doc.codigoISO}
                  </TableCell>

                   <TableCell
  sx={{
    cursor: "pointer",
    color: "primary.main",
  }}
  onClick={() => abrirItem(doc)}
>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
    }}
  >
    {doc.origemDocumento === "rota" ? (
      <LinkIcon fontSize="small" color="action" />
    ) : (
      <DescriptionIcon fontSize="small" color="action" />
    )}

    {doc.titulo}
  </Box>
</TableCell>


                    <TableCell>{doc.tipo}</TableCell>
                    <TableCell>REV.{doc.revisaoAtual}</TableCell>
                    <TableCell>{formatarDataBR(doc.dataEmissao)}</TableCell>
                    <TableCell>{doc.responsavel}</TableCell>
                    <TableCell>
                      <Chip label={doc.status} size="small" />
                    </TableCell>
                    <TableCell>{doc.localArmazenamento}</TableCell>
                        <TableCell>{doc.observacoes}</TableCell>
                        <TableCell>{doc.dadosSensiveis}</TableCell>
                        <TableCell>{doc.tipoDado}</TableCell>
                        <TableCell>{doc.justificativaTratamento}</TableCell>
                        <TableCell>{doc.acessoRestrito}</TableCell>
                        <TableCell>{doc.medidaProtecao}</TableCell>

                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            ref={barraInferiorRef}
            onScroll={(event) => {
              if (tabelaRef.current) {
                tabelaRef.current.scrollLeft = event.currentTarget.scrollLeft;
              }
            }}
            aria-label="Rolagem horizontal da Lista Mestra"
            sx={{ position: "fixed", bottom: 0, left: 0, width: "100vw", height: 20, overflowX: "auto", overflowY: "hidden", bgcolor: "background.paper", borderTop: "1px solid #94a3b8", zIndex: 1300 }}
          >
            <Box sx={{ width: larguraRolagem, height: 1 }} />
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}
